if (!customElements.get('velora-sticky-purchase')) {
  customElements.define('velora-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.main = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.main) return;
      this.abort = new AbortController();
      document.documentElement.classList.add('velora-purchase-ready');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.chosen = this.dataset.chosen === 'true';
      this.select = this.querySelector('select');
      this.add = this.querySelector('button');
      this.label = this.add.querySelector('span');
      this.price = this.querySelector('.velora-purchase__price');
      this.quantity = this.querySelector('.velora-purchase__quantity');
      this.status = this.querySelector('.velora-purchase__status');
      this.pendingId = null;
      this.past = false;
      const options = { signal: this.abort.signal };
      this.main.querySelectorAll('.velora-purchase-notes a').forEach(link => link.addEventListener('click', () => { const detail = document.querySelector(link.getAttribute('href')); if (detail) detail.open = true; }, options));
      this.main.addEventListener('change', e => {
        if (e.target.closest('variant-selects')) {
          this.chosen = true;
          this.selecting = true;
          this.update();
        }
      }, options);
      this.select?.addEventListener('change', () => this.choose(), options);
      this.add.addEventListener('click', () => {
        if (!this.chosen && this.select) {
          this.select.focus();
          try { this.select.showPicker?.(); } catch {}
          return;
        }
        const submit = this.main.querySelector('product-form button[name="add"]');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || this.pendingId || this.selecting) return;
        this.busy = true;
        this.update();
        submit.form.requestSubmit(submit);
        this.busyTimer = setTimeout(() => { this.busy = false; this.update(); }, 1000);
      }, options);
      this.observer = new MutationObserver(() => {
        const input = this.main.querySelector('product-form input[name="id"]');
        if (this.pendingId && input?.value === this.pendingId && !input.disabled) this.pendingId = null;
        const picker = this.main.querySelector('variant-selects script[data-selected-variant]');
        if (picker && !this.pendingId) {
          try {
            const variant = JSON.parse(picker.textContent);
            if (variant?.id === Number(input?.value)) this.selecting = false;
          } catch {}
        }
        this.observeButton();
        this.update();
      });
      this.observer.observe(this.main, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','value'] });
      this.overlayObserver = new MutationObserver(() => this.update());
      this.overlayObserver.observe(document.body,{subtree:true,attributes:true,attributeFilter:['class','open','aria-hidden']});
      this.visibility = new IntersectionObserver(entries => {
        const entry = entries[entries.length - 1];
        if (entry.isIntersecting && entry.boundingClientRect.bottom >= 16) this.past = false;
        this.update();
      });
      document.addEventListener('scroll', () => { if (this.scrollFrame) return; this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.update(); }); }, { ...options, passive:true, capture:true });
      window.addEventListener('resize', () => this.update(), options);
      this.observeButton();
      this.update();
    }
    observeButton() {
      const button = this.main.querySelector('product-form button[name="add"]');
      if (button && button !== this.observedButton) {
        if (this.observedButton) this.visibility.unobserve(this.observedButton);
        this.observedButton = button;
        this.visibility.observe(button);
      }
    }
    choose() {
      const variant = this.variants.find(v => String(v.id) === this.select.value);
      if (!variant) { this.chosen=false; this.update(); return; }
      const picker = this.main.querySelector('variant-selects');
      if (!picker) return;
      let trigger;
      Array.from(picker.querySelectorAll('fieldset,select')).forEach((group,index) => {
        const value = variant.options[index];
        if (group.tagName === 'SELECT') {
          group.value = value;
          trigger = group;
        } else {
          const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find(input => input.value === value);
          if (radio) { radio.checked = true; trigger = radio; }
        }
      });
      if (!trigger) return;
      this.chosen = true;
      this.pendingId = String(variant.id);
      trigger.dispatchEvent(new Event('change',{bubbles:true}));
      this.update();
    }
    update() {
      const bottom = this.observedButton?.getBoundingClientRect().bottom;
      this.past = bottom !== undefined && (this.past ? bottom < 16 : bottom < -8);
      const overlay = document.querySelector('cart-drawer.active, .menu-drawer-container[open], .product-media-modal[open], .search-modal[open], details-modal details[open]');
      const show = this.past && !overlay;
      if (this.hidden === show) this.hidden = !show;
      document.documentElement.classList.toggle('velora-purchase-visible',show);
      const input = this.main.querySelector('product-form input[name="id"]');
      const submit = this.main.querySelector('product-form button[name="add"]');
      const variant = this.variants.find(v => String(v.id) === input?.value);
      if (this.select && !this.pendingId) this.select.value = this.chosen && variant ? String(variant.id) : '';
      const livePrice = this.main.querySelector('.product__info-container .price');
      if (livePrice) {
        const compactPrice = livePrice.cloneNode(true);
        compactPrice.removeAttribute('id');
        compactPrice.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        compactPrice.querySelectorAll('.price-item').forEach(item => {
          const text = item.textContent.trim().replace(/[.,]00(?=\s*[^\d]*$)/, '');
          const currency = text.match(/\s*(₪)\s*$/);
          if (currency) {
            const symbol = document.createElement('span');
            symbol.className = 'velora-price__currency';
            symbol.textContent = currency[1];
            item.replaceChildren(document.createTextNode(text.slice(0, currency.index).trim()), symbol);
          } else item.textContent = text;
        });
        if (this.price.innerHTML !== compactPrice.outerHTML) this.price.innerHTML = compactPrice.outerHTML;
      }
      const count = this.main.querySelector('input[name="quantity"]')?.value || '1';
      if (this.quantity) this.quantity.textContent = Number(count) > 1 ? this.dataset.quantityLabel + ': ' + count : '';
      const loading = this.busy || this.pendingId || this.selecting || submit?.classList.contains('loading');
      const unavailable = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || !variant?.available;
      this.add.disabled = Boolean(loading || (this.chosen && unavailable));
      const text = loading ? this.dataset.loadingLabel : !this.chosen && this.select ? this.dataset.chooseLabel : unavailable ? this.dataset.unavailableLabel : this.dataset.addLabel;
      if (this.label.textContent !== text) this.label.textContent = text;
      const error = this.main.querySelector('.product-form__error-message')?.textContent.trim() || '';
      if (this.status.textContent !== error) this.status.textContent = error;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.observer?.disconnect(); this.overlayObserver?.disconnect(); this.visibility?.disconnect();
      clearTimeout(this.busyTimer);
      cancelAnimationFrame(this.scrollFrame);
      document.documentElement.classList.remove('velora-purchase-visible', 'velora-purchase-ready');
    }
  });
}
